// Smoothly scroll an element by a delta, honoring the user's reduced-motion
// preference. Shared by the vertical and horizontal overflow affordances.
const prefersReducedMotion = () => typeof window !== 'undefined'
  && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const scrollByPage = (el, { left = 0, top = 0 } = {}) => {
  if (!el) return;
  el.scrollBy({ left, top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
};

export default scrollByPage;
